import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../toolkit/uicomponentcss';

export interface NavigationCSSStyle extends UIComponentCSSStyle
{
    
}

export class NavigationCSSStyleImpl extends UIComponentCSSStyleImpl implements NavigationCSSStyle
{   
   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/navigation/navigationcss.tsx